import { useMutation } from '@tanstack/react-query'
import { getRequest } from 'utils/api/apiRequest'

export const useGetQRCode = () => {
  return useMutation({
    mutationFn: () => getRequest<{ qrCode: string }>(`/2fa/qrcode`),
  })
}
